import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    actions,
    formatColumnTitle,
    SPECIAL_PERMISSIONS,
    TAB_OPTIONS,
    WEBSITE_ROLES_MODEL,
} from '../Model/AllowedModules';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import {
    IconCheckbox,
    IconCheckboxChecked,
    IconCheckboxUnchecked,
} from '../../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { handleSelectAllPermissions, isAllPermissionsSelected } from './CommonsPermissions';
import { MODELS } from '../../../../../Apis/Models';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const WebsiteRolesApp = ({ web = [], selectedPermissions = [], setSelectedPermissions, readOnly }) => {
    const { t } = useTranslation();
    const [selectedInnerView, setSelectedInnerView] = useState(WEBSITE_ROLES_MODEL[0]?.id);
    const tableId = 'tbl_wra_table';
  
    const handleStepSelectedInnerView = (tab) => {
        setSelectedInnerView(tab);
    };
    const getAction = (permissionName = '') => {
        const action = permissionName.trim().split('_').pop()?.toLowerCase();

        return action === ACTION_MODEL.VIEW ? ACTION_MODEL.READ : action;
    };
    const selectedRole = WEBSITE_ROLES_MODEL.find((item) => item.id === selectedInnerView);
    const permissions = (web || []).filter(
        (permission) =>
            permission.moduleId === selectedRole?.id ||
            selectedRole?.children?.some((child) => child.id === permission.moduleId),
    );
    const standardColumns = actions.filter((action) => {
        return permissions.some((permission) => {
            const permAction = getAction(permission.name);
            return permAction === action.toLowerCase();
        });
    });

    const customColumns = [
        ...new Set(
            permissions
                .filter(
                    (permission) =>
                        SPECIAL_PERMISSIONS.includes(permission.name) || !actions.includes(getAction(permission.name)),
                )
                .map((permission) => permission.name),
        ),
    ];

    const columns = [...new Set([...standardColumns, ...customColumns])].filter(c => c && c.trim());
    const thead = [
        <CustomTh tableId={tableId} key={'module'}>
            {''}
        </CustomTh>,

        ...columns.map((column) => (
            <CustomTh tableId={tableId} key={column}>
                <CustomTooltip text={formatColumnTitle(t(column))}>
                    <div className='text-center text-capitalize'>{formatColumnTitle(t(column))}</div>
                </CustomTooltip>
            </CustomTh>
        )),
    ];
    const handleCheckboxChange = (permissionId, checked) => {
        setSelectedPermissions((prev = []) => {
            if (checked) {
                const exists = prev.some((item) => item.id === permissionId);
                if (exists) return prev;
                return [...prev, { id: permissionId }];
            }
            return prev.filter((item) => item.id !== permissionId);
        });
    };

    const tbody = {
        body: (selectedRole?.children || []).map((child) => {
            const childPermissions = permissions.filter((permission) => permission.moduleId === child.id);

            return (
                <>
                    <CustomTd tableId={tableId}>
                        <p className='fs-12px font-color-text-950 ibl-font-w-600'>{t(child.translation)}</p>
                    </CustomTd>

                    {columns.map((column) => {
                        const permission = childPermissions.find((permission) => {
                            if (actions.includes(column)) {
                                return permission.name.trim().toLowerCase().endsWith(column.toLowerCase());
                            }

                            return permission.name === column;
                        });
                        return (
                            <CustomTd tableId={tableId} key={`${child.id}-${column}`}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <CustomCheckbox
                                        disabled={readOnly}
                                        icon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxUnchecked className='icon-color-general-950' />
                                            )
                                        }
                                        checkedIcon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxChecked className='icon-color-shades-800' />
                                            )
                                        }
                                        checked={
                                            permission
                                                ? selectedPermissions.some((item) => item.id === permission?.id)
                                                : false
                                        }
                                        onChange={(e) =>
                                            permission && handleCheckboxChange(permission.id, e.target.checked)
                                        }
                                    />
                                </div>
                            </CustomTd>
                        );
                    })}
                </>
            );
        }),

        data: selectedRole?.children || [],
    };

    const selectedRoleCount = selectedPermissions.filter((permission) =>
        web?.some((item) => item.id === permission.id && item.moduleId === selectedRole?.id),
    ).length;

    const currentPermissions = permissions.filter((permission) => permission?.id);

    const isAllChecked = isAllPermissionsSelected(currentPermissions, selectedPermissions);

    const handleSelectAll = (checked) => {
        handleSelectAllPermissions(checked, currentPermissions, setSelectedPermissions);
    };

    const roleMessages = {[MODELS.Guard]: 'guard_module_home_permission_description',};
    const messageKey = roleMessages[selectedRole?.id];


    return {
        t,
        selectedInnerView,
        handleStepSelectedInnerView,
        selectedRole,
        thead,
        tbody,
        selectedRoleCount,
        isAllChecked,
        handleSelectAll,
        messageKey
    };
};

export default WebsiteRolesApp;
